/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

import type { Date } from './Date';

export type ScheduleExecution = {
    /**
     * The execution mode defines when or how Schedule will be cancelled, processed the last time.
     *
     */
    executionMode: ScheduleExecution.executionMode;
    /**
     * Execution due date at the end of the month. (DUE_DAY_OF_MONTH, DUE_LAST_DAY_OF_MONTH)
     *
     */
    executionDueMode: ScheduleExecution.executionDueMode;
    /**
     * The interval period of scheduled execution. (Restrictions to ENUM values could be defined in local API documentations)
     *
     * Validations:
     * - `WEEKLY` - can be combined only with `DUE_DAY_OF_MONTH` due mode
     * - `IRREGULAR` - requires `stoppages` field
     *
     */
    executionInterval: ScheduleExecution.executionInterval;
    nextCreationDate?: (Date & string);
    lastCreationDate?: (Date & string);
    /**
     * Array of months when no payment order is generated from Schedule (Only applicable with interval period IRREGULAR, when stoppages is used, then no break should be provided).
     *
     * Validations:
     * - can be combined only with `IRREGULAR` interval
     *
     */
    stoppages?: Array<'JANUARY' | 'FEBRUARY' | 'MARCH' | 'APRIL' | 'MAY' | 'JUNE' | 'JULY' | 'AUGUST' | 'SEPTEMBER' | 'OCTOBER' | 'NOVEMBER' | 'DECEMBER'>;
    /**
     * Due date day in execution interval of Schedule processing.
     *
     * Validations:
     * - can be combined only with `DUE_DAY_OF_MONTH` due mode
     * - 1-5 for `WEEKLY`
     * - 1-31 for `MONTHLY`, `QUARTERLY`, `HALFYEARLY`, `YEARLY`, `IRREGULAR`
     *
     */
    intervalDueDay?: number;
    /**
     * Due date month in execution interval of Schedule processing.
     *
     * Validations:
     * - N/A for `WEEKLY` and `MONTHLY`
     * - 1-3 for `QUARTERLY`
     * - 1-6 for `HALFYEARLY`
     * - 1-12 for `YEARLY`
     *
     */
    intervalDueMonth?: number;
    /**
     * Requested due date of created open order will be shifted by specified number of days
     *
     */
    orderExecutionOffsetDays?: number;
};

export namespace ScheduleExecution {

    /**
     * The execution mode defines when or how Schedule will be cancelled, processed the last time.
     *
     */
    export enum executionMode {
        UNTIL_CANCELLATION = 'UNTIL_CANCELLATION',
        UNTIL_DATE = 'UNTIL_DATE',
    }

    /**
     * Execution due date at the end of the month. (DUE_DAY_OF_MONTH, DUE_LAST_DAY_OF_MONTH)
     *
     */
    export enum executionDueMode {
        DUE_DAY_OF_MONTH = 'DUE_DAY_OF_MONTH',
        DUE_LAST_DAY_OF_MONTH = 'DUE_LAST_DAY_OF_MONTH',
    }

    /**
     * The interval period of scheduled execution. (Restrictions to ENUM values could be defined in local API documentations)
     *
     * Validations:
     * - `WEEKLY` - can be combined only with `DUE_DAY_OF_MONTH` due mode
     * - `IRREGULAR` - requires `stoppages` field
     *
     */
    export enum executionInterval {
        WEEKLY = 'WEEKLY',
        MONTHLY = 'MONTHLY',
        QUARTERLY = 'QUARTERLY',
        HALFYEARLY = 'HALFYEARLY',
        YEARLY = 'YEARLY',
        IRREGULAR = 'IRREGULAR',
    }


}

